import {Injectable} from '@angular/core';
import {Actions, Effect} from '@ngrx/effects';
import {Observable} from 'rxjs/Observable';
import {Action} from '@ngrx/store';
import * as register from '../actions/register';
import * as auth from '../actions/authentication';
import {RegistrationService} from '../services/registration';
import { of } from 'rxjs/observable/of';
import { ErrorModel } from '../models/error-model';

@Injectable()
export class RegisterEffects {
  @Effect()
  requestAccess$: Observable<Action> = this.actions$
    .ofType(register.REQUEST_ACCESS)
    .map((action: register.RequestAccessAction) => action.payload)
    .switchMap(req => {

      const nextLookup$ = this.actions$.ofType(register.REQUEST_ACCESS).skip(1);
      const errorMessage = 'Error processing access request.';
      return this.registrationService.submitRequest(req)
        .takeUntil(nextLookup$)
        .map(p => new register.RequestAccessCompleteAction(p))
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  @Effect()
  loadAccessRequests$: Observable<Action> = this.actions$
    .ofType(register.LOAD_ACCESS_REQUESTS)
    .map((action: register.LoadAccessRequestsAction) => action.payload)
    .switchMap(typ => {

      const nextLookup$ = this.actions$.ofType(register.LOAD_ACCESS_REQUESTS).skip(1);
      const errorMessage = 'Error loading access requests.';
      return this.registrationService.pendingRequests(typ)
        .takeUntil(nextLookup$)
        .map(reqs => new register.LoadAccessRequestsCompleteAction(reqs))
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  @Effect()
  approveAccess$: Observable<Action> = this.actions$
    .ofType(register.APPROVE_ACCESS_REQUEST)
    .map((action: register.ApproveAccessRequestAction) => action.payload)
    .switchMap(req => {

      const nextLookup$ = this.actions$.ofType(register.APPROVE_ACCESS_REQUEST).skip(1);
      const errorMessage = 'Error approving access request.';
      return this.registrationService.grantRequest(req)
        .takeUntil(nextLookup$)
        .map(p => new register.ApproveAccessRequestCompleteAction(p))
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  @Effect()
  denyAccess$: Observable<Action> = this.actions$
    .ofType(register.DENY_ACCESS_REQUEST)
    .map((action: register.DenyAccessRequestAction) => action.payload)
    .switchMap(req => {

      const nextLookup$ = this.actions$.ofType(register.DENY_ACCESS_REQUEST).skip(1);
      const errorMessage = 'Error denying access request.';
      return this.registrationService.denyRequest(req)
        .takeUntil(nextLookup$)
        .map(p => new register.DenyAccessRequestCompleteAction(p))
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  constructor(private actions$: Actions, private registrationService: RegistrationService) {}

}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/effects/register.ts